interface LogData {
  module?: string
  data?: any
  [key: string]: any
}

class Logger {
  private formatMessage(level: string, message: string, data?: LogData): string {
    const timestamp = new Date().toISOString()
    const module = data?.module ? `[${data.module}]` : ''
    const dataStr = data ? ` ${JSON.stringify(data)}` : ''
    return `${timestamp} ${level.toUpperCase()} ${module} ${message}${dataStr}`
  }

  info(message: string, data?: LogData) {
    console.log(this.formatMessage('info', message, data))
  }

  error(message: string, data?: LogData) {
    console.error(this.formatMessage('error', message, data))
  }

  warn(message: string, data?: LogData) {
    console.warn(this.formatMessage('warn', message, data))
  }

  debug(message: string, data?: LogData) {
    if (process.env.NODE_ENV === 'development') {
      console.debug(this.formatMessage('debug', message, data))
    }
  }
}

const logger = new Logger()

// Export both the instance and as default for different import patterns
export { logger }
export default logger

// Also export the old 'log' name for compatibility with API.ts
export { logger as log }
